import React, { } from 'react'

import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'

import Divider from '@material-ui/core/Divider'
import Tooltip from '@material-ui/core/Tooltip'
import Avatar from '@material-ui/core/Avatar'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import moment from 'moment'

export const HistoryList = ({ classes, history }) => {
  return (
    <>
      <ListItem>
        <ListItemAvatar>
          <Tooltip title={`${history.firstName} ${history.lastName}`} placement='top'>
            <Avatar className={classes.commentAvatar} src={history.avatarPath}>
              {history.firstName.substring(0, 1)}{history.lastName.substring(0, 1)}
            </Avatar>
          </Tooltip>
        </ListItemAvatar>
        <ListItemText
          className='text-dark'
          disableTypography
          primary={
            <Grid container>
              <Grid item xs={9} container direction='row'>
                <Typography variant='body1' className='font-weight-bold text-wrap w-100'>{history.firstName} {history.lastName}</Typography>
              </Grid>
            </Grid>
          }
          secondary={
            <Typography component='span' variant='body2' className='text-wrap w-100'>
              <span className='text-capitalize'>{history.historyAction}</span> on
              <span className='text-primary font-italic'> {moment.unix(history.timestamp).format('MMMM Do YYYY, h:mma')}</span>
            </Typography>
          }
        />
      </ListItem>
      <Divider variant='inset' component='li' />
    </>
  )
}

export default HistoryList
